import { render, staticRenderFns } from "./Body1.vue?vue&type=template&id=25507347&"
import script from "./Body1.vue?vue&type=script&lang=js&"
export * from "./Body1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports